import { render, staticRenderFns } from "./VisitorsView.vue?vue&type=template&id=94bfd1b8&"
import script from "./VisitorsView.vue?vue&type=script&lang=js&"
export * from "./VisitorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports